import * as Yup from 'yup';
import { passwordNotMatch, passwordRuleSet, requiredField } from './utils/messages';

const regexPassword = /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

export const changePasswordValidationSchema = Yup.object().shape({
  current_password: Yup.string().matches(regexPassword, passwordRuleSet).required(requiredField),
  new_password: Yup.string().matches(regexPassword, passwordRuleSet).required(requiredField),
  password_confirm: Yup.string()
    .oneOf([Yup.ref('new_password'), null], passwordNotMatch)
    .required(requiredField),
});
